var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"account btn-green-background btn btn-flex",attrs:{"target":"_blank","href":_vm.validateUrl('/client/login/')}},[_c('img',{staticClass:"vertical-align-bottom icon",attrs:{"src":_vm.getPict('account-black', 'svg', 'black'),"alt":'Espace personnel',"width":"26","height":"26"}}),_vm._v(" Me connecter ")])
}
var staticRenderFns = []

export { render, staticRenderFns }